<template>
    <div class="app flex-row align-items-center multiselect-dropdown">
        <b-container>
            <b-row class="justify-content-center">
                <b-col cols="6">
                    <b-card header-tag="header">
                        <template #header>
                            <h2 class="">Edit Resource</h2>
                        </template>
                       <b-card-body>
                            <b-form v-on:submit.prevent="UpdateResource">
                                <b-form-group label="Select Community:">
                                    <multiselect v-model="communityValues" name="community" v-validate="'required'"
                                        :options="communityOptions" :multiple="false" label="name" track-by="name"
                                        placeholder="Assign a community" @select="updateCircleSelect"
                                        @remove="removeCircles">
                                    </multiselect>
                                    <div class="selection-required" v-if="errors.has('community')">
                                        {{ errors.first('community') }}
                                    </div>
                                </b-form-group>
                                <b-form-group label="Select Circle:">
                                    <multiselect v-model="circleValues" name="circle" :options="circleOptions"
                                        :multiple="false" label="name" track-by="name" placeholder="Assign a circle"
                                        :allow-empty="true">
                                    </multiselect>
                                </b-form-group>
                                <b-form-group label="Resource Name" label-for="resource_name">
                                    <b-form-input type="text" name="resource_name" v-model="resource.name"
                                        v-validate="{ required: true, max: 60 }" :state="validateState('resource_name')"
                                        placeholder="Enter resource name"
                                        @input="resource.name = sanitizeInput($event)">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="errors.has('resource_name')">
                                        {{ errors.first('resource_name') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group label="Resource Type" label-for="resource_type">
                                    <b-form-select
                                        name="resource_type"
                                        class="cursor-pointer capitalize"
                                        v-model="resource.type"
                                        v-validate="{ required: true, max:60 }"
                                        :state="validateState('resource_type')"
                                        :options="resourceTypeOptions"
                                        placeholder="Select resource type"
                                    >
                                    <option disabled value="">Select resource type</option>
                                    </b-form-select>
                                    <b-form-invalid-feedback v-if="errors.has('resource_type')">
                                        {{ errors.first('resource_type') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group
                                label="Resource Access"
                                label-for="resource_roles"
                                >
                                <b-form-select
                                    name="resource_roles"
                                    class="cursor-pointer capitalize"
                                    v-model="resource.roles"
                                    v-validate="{ required: true, max:60 }"
                                    :state="validateState('resource_roles')"
                                    :options="resourceRoleOptions"
                                    placeholder="Select resource roles"
                                >
                                <option disabled value="">Select resource roles</option>
                                </b-form-select>
                                <b-form-invalid-feedback v-if="errors.has('resource_roles')">
                                    {{ errors.first('resource_roles') }}
                                </b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group
                                label="Description"
                                label-for="description"
                                >
                                    <b-form-textarea
                                    name="description"
                                    v-model="resource.description"
                                    rows="3"
                                    max-rows="6"
                                    v-validate="{ required: true, max:2000 }"
                                    :state="validateState('description')"
                                    placeholder="Enter resource description"
                                    @input="resource.description = sanitizeInput($event)">
                                    </b-form-textarea>
                                    <b-form-invalid-feedback v-if="errors.has('description')">
                                    {{errors.first('description')}}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group
                                label="URL"
                                label-for="email"
                                >
                                    <b-form-input
                                    type="text"
                                    name="url"
                                    v-model="resource.url"
                                    v-validate="{ required: true, regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?$/ }"
                                    :state="validateState('url')"
                                    placeholder="Enter URL of resource"
                                    @input=" resource.url = sanitizeUrl($event)"
                                    >
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="errors.has('url')">
                                    {{errors.first('url')}}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group label="Tags" label-for="tags">
                                    <b-form-input
                                        type="text"
                                        name="tags"
                                        v-model="formattedTags"
                                        placeholder="Enter tags, separated by commas">
                                    </b-form-input>
                                </b-form-group>
                                <b-form-group label="Resources Definition" label-for="definition">
                                    <b-form-textarea
                                        id="definition"
                                        :value="resource.gaia_definition || ''"
                                        rows="4"
                                        max-rows="8"
                                        disabled
                                        placeholder="No definition available yet.">
                                    </b-form-textarea>
                                </b-form-group>
                                <div class="d-flex align-items-center justify-content-between mt-2">
                                    <div class="d-flex align-items-center">
                                        <b-button type="submit" variant="primary tab-focus">Update</b-button>
                                        <span v-if="resource.lastUpdated || resource.updatedAt" class="ml-3 text-muted small">
                                            Last updated: {{ formattedLastUpdated }}
                                        </span>
                                    </div>
                                    <b-button
                                        variant="outline-secondary"
                                        title="Refresh definition and tags"
                                        @click.prevent="refreshDefinition">
                                        <i class="fa fa-sync"></i>
                                    </b-button>
                                </div>
                            </b-form>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios';
import Multiselect from 'vue-multiselect';
import { sanitizeInput, sanitizeUrl, sanitizeHtmlTemplate, sanitizeResourceDescription } from '../../../utils/sanitizer';
export default {
    name: 'AddResource',
    components: { Multiselect },
    data() {
        return {
            token: localStorage.getItem('token'),
            resourceId: '',
            resource: {
                name: '',
                type: '',
                roles: '',
                description: '',
                url: '',
                communityValues: [],
                communities: [],
                circleValues: [],
                communityId: '',
                circles: '',
                circleId: '',
                tags: '',
                definition: '',
                lastUpdated: null
            },
            communities: [],
            communityOptions: [],
            communityValues: [],
            circleOptions: [],
            circleValues: [],
            resourceTypeOptions: ['job', 'staff', 'event', 'document', 'course', 'website'],
            resourceRoleOptions: [],
            checkCircleOnce: true,
            submitting: false,
            submitSuccess: false,
            refreshing: false,
        }
    },
    created() {
        let authUser = JSON.parse(localStorage.getItem('authUser'));
        // if (authUser && authUser.role === 'Admin') {
        //     this.$router.push('/');
        // }
        if(!this.$route.params.resource_id) {
            this.$router.push('/');
        }
        this.resourceId = this.$route.params.resource_id;
        this.loadData();
        const dict = {
            custom: {
                resource_name: {
                    required: "Please enter resource name.",
                    max: "resource name cannot be more than 60 characters.",
                },
                description: {
                    required: "Please enter resource description.",
                    max: "resource description cannot be more than 2000 characters.",
                },
                url: {
                    required: "Please enter URL.",
                    regex: "Please enter valid URL"
                }
            }
        };
        this.$validator.localize('en', dict);
    },
    computed: {
        formattedLastUpdated() {
            const date = this.resource.lastUpdated || this.resource.updatedAt;
            if (!date) return '';
            return new Date(date).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        },
        formattedTags: {
            get() {
                return this.formatTagsForDisplay(this.resource.tags);
            },
            set(value) {
                this.resource.tags = this.formatTagsForStorage(value);
            }
        }
    },
    methods: {
        ensureAllMembersRole(options) {
            const normalized = (options || [])
                .map(role => (role || '').toString().trim().toLowerCase())
                .filter(Boolean);

            if (!normalized.includes('all_members')) {
                normalized.push('all_members');
            }

            return normalized;
        },
        async loadData() {
            await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/filter-community`, {headers: {'x-access-token': this.token}})
                    .then(response => {
                        if(response.status === 200) {
                            if(Array.isArray(response.data)) {
                                this.communities = response.data;
                            }
                            if(this.communities.length) {
                                this.communityOptions = this.communities.map(community => ({
                                    name: community.name,
                                    id: community._id,
                                    additionalParams: community.additionalParams,
                                    content: community.content
                                }));
                            }
                        }
                    })
                    .catch(err => {
                        if (err.response.status === 401) {
                            localStorage.removeItem('authUser');
                            this.$router.push('/login');
                        }
                    });
                await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/resource/${this.resourceId}`, {headers: {'x-access-token': this.token}}).then(response => {
                    if(response.data.resource) {
                        this.resource = response.data.resource;
                        // Ensure tags is a string in the correct format after loading
                        if (Array.isArray(this.resource.tags)) {
                            this.resource.tags = this.resource.tags.join('|');
                        } else if (typeof this.resource.tags !== 'string') {
                             // If it's not an array or string, default to empty string
                            this.resource.tags = '';
                        }
                        const userComm = this.resource.community;
                        const community = this.communities.find(community => community._id === userComm);
                        this.resourceRoleOptions = community.content.configureFields.memberRole.value;

                        if (community) {
                            this.communityValues = {
                                name: community.name,
                                id: community._id,
                                additionalParams: community.additionalParams
                            };
                        }
                        this.updateCircleSelect();
                }
                    }).catch(err => {
                console.log(err);
                if (err.response.status === 401) {
                    localStorage.removeItem('authUser');
                    this.$router.push('/login');
                }
            });
        },
        formatTagsForDisplay(tags) {
            if (Array.isArray(tags)) {
                return tags.map(tag => tag.split('|').join(', ')).join(', ');
            } else if (typeof tags === 'string') {
                return tags.split('|').join(', ');
            }
            return '';
        },
        formatTagsForStorage(tagsString) {
            return tagsString.split(',').map(tag => tag.trim()).join('|');
        },
        UpdateResource() {
            this.$validator.validateAll().then(result => {
                this.prepareResourceData();
                if (result) {
                    let payload = {
                        name: this.resource.name,
                        type: this.resource.type,
                        roles: this.resource.roles,
                        url: this.resource.url,
                        description: this.resource.description,
                        community: this.resource.communityId,
                        communities: this.resource.communities,
                        circle: (this.resource.circles) ? this.resource.circles : '',
                        circleId: (this.resource.circleId) ? this.resource.circleId : '',
                        tags: this.resource.tags,
                        resourceRoleOptions: this.resourceRoleOptions
                    }
                    this.submitting = true;
                    this.submitSuccess = false;
                    this.axios.put(`${process.env.VUE_APP_API_BASE_URL}/dashboard/resource/${this.resourceId}/update`, payload, { headers: { 'x-access-token': this.token } }).then(response => {
                        this.submitting = false;
                        this.submitSuccess = true;

                        if (response.data.gaia_definition) {
                            this.resource.gaia_definition = response.data.gaia_definition;

                            if (response.data.gaia_definition.includes('--Check URL--')) {
                                this.$bvToast.toast('Resource saved but the URL could not be verified. Please check the URL.', {
                                    title: 'Warning',
                                    variant: 'warning',
                                    solid: true,
                                    autoHideDelay: 5000
                                });
                            } else {
                                this.$bvToast.toast('Resource updated successfully.', {
                                    title: 'Success',
                                    variant: 'success',
                                    solid: true,
                                    autoHideDelay: 3000
                                });
                            }
                        } else {
                            this.$bvToast.toast('Resource updated successfully.', {
                                title: 'Success',
                                variant: 'success',
                                solid: true,
                                autoHideDelay: 3000
                            });
                        }

                        setTimeout(() => this.$router.push('/dashboard/resources'), 2000);
                    }).catch(err => {
                        this.submitting = false;
                        this.$bvToast.toast('Failed to update resource. Please try again.', {
                            title: 'Error',
                            variant: 'danger',
                            solid: true,
                            autoHideDelay: 3000
                        });

                        if (err.response && err.response.status === 401) {
                            localStorage.removeItem('authUser');
                            this.$router.push('/login');
                        }
                    });
                }
            });
        },
        validateState(ref) {
            if (this.errors.has(ref)) {
                return !this.errors.has(ref);
            } else {
                return null;
            }
        },
        prepareResourceData() {
            if (this.communityValues) {
                this.resource.communityId = this.communityValues.id;
            }
            const hasCircle = this.circleValues && this.circleValues.id;
            this.resource.circles = hasCircle ? this.circleValues.short : '';
            this.resource.circleId = hasCircle ? this.circleValues.id : '';
        },
        updateCircleSelect(community) {
                this.circleValues = '';
                const selectedCommunityId = this.communityValues.id;
                const circles = [];
                if (selectedCommunityId) {
                    const community = this.communities.find(c => c._id === selectedCommunityId);
                    if (community) {
                        circles.push(...(community.additionalParams || []));
                    }
                }
            // Parse roles from memberRole.value
            if (this.resourceRoleOptions) {
                const parsedRoles = Array.isArray(this.resourceRoleOptions)
                    ? this.resourceRoleOptions
                    : this.resourceRoleOptions
                        .split(',')
                        .map(r => r.trim().toLowerCase())
                        .filter(Boolean);
                this.resourceRoleOptions = this.ensureAllMembersRole(parsedRoles);
            } else {
                this.resourceRoleOptions = ['student', 'alumni', 'faculty', 'all_members'];
            }
            this.circleOptions = circles
                .filter(circle => circle != null && circle.name != undefined && circle.name != null && circle.name != '')
                .map(circle => ({
                    name: circle.name,
                    id: circle._id,
                    short: circle.short,
                }));
                    if(this.checkCircleOnce){
                        this.circleValues = circles
                        .filter(circle => circle !== null && this.resource.circle.includes(circle.short))
                        .map(circle => ({
                            name: circle.name,
                            short: circle.short,
                            id: circle._id
                        }))[0] || {};
                    this.checkCircleOnce = false;
                }
        },
        removeCircles(removedCommunity) {
            this.updateCircleSelect();
        },
        capitalizedOptions(options) {
            let capitalizedOptions = [];
            capitalizedOptions = options.map(option => {
                return option.charAt(0).toUpperCase() + option.slice(1);
            });
            return capitalizedOptions;
        },
        sanitizeInput(input) {
            return sanitizeInput(input);
        },
        sanitizeUrl(url) {
            return sanitizeUrl(url);
        },
        sanitizeHtmlTemplate(template) {
            return sanitizeHtmlTemplate(template);
        },
        sanitizeResourceDescription(description) {
            return sanitizeResourceDescription(description);
        },
        async refreshDefinition() {
            this.refreshing = true;
            try {
                const response = await this.axios.post(
                    `${process.env.VUE_APP_API_BASE_URL}/dashboard/resource/${this.resourceId}/refresh-definition`,
                    { url: this.resource.url }
                );

                if (response.data.gaia_definition) {
                    this.resource.gaia_definition = response.data.gaia_definition;

                    if (response.data.gaia_definition.includes('--Check URL--')) {
                        this.$bvToast.toast('Definition generated but the URL could not be verified. Please check the URL.', {
                            title: 'Warning',
                            variant: 'warning',
                            solid: true,
                            autoHideDelay: 5000
                        });
                    } else {
                        this.$bvToast.toast('Definition refreshed successfully.', {
                            title: 'Success',
                            variant: 'success',
                            solid: true,
                            autoHideDelay: 3000
                        });
                    }
                }
            } catch (err) {
                this.$bvToast.toast('Failed to refresh definition. Please try again.', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true,
                    autoHideDelay: 3000
                });
            } finally {
                this.refreshing = false;
            }
        },
    }
}
</script>
